import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'LAUDO_IMPORTACAO_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'LAUDO_IMPORTACAO_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize('laudoImportacaoForm', registro)
    ];
}

export function getListaResumido() {
	const request = axios.get(`${consts.API_URL}/laudoImportacao?resumido=true`);
	return {
		type: 'LAUDO_IMPORTACAO_LISTADO',
		payload: request
	};
}

export function getLista(competencia, id_hospital) {
	return (dispatch, getState) => {
		dispatch({
			type: 'LAUDO_IMPORTACAO_ITEM_LISTADO',
			payload: {
				data: []
			}
		});
		axios.get(`${consts.API_URL}/laudoImportacao?competencia=${competencia}&id_hospital=${id_hospital}`).then(resp => {
			dispatch({
				type: 'LAUDO_IMPORTACAO_ITEM_LISTADO',
				payload: resp
			});
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getListaGrupoFaturamentoRadiologista(evento) {
	return (dispatch, getState) => {
		axios.get(`${consts.API_URL}/grupoFaturamentoRadiologista/listarGeral`).then(resp => {
			dispatch({
				type: 'LAUDO_GRUPO_FATURAMENTO_RADIOLOGISTA_LISTADO',
				payload: resp
			});
			
			try {
				if (evento) {
					evento();
				}
			} catch(ex) {

			}

		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getListaContratoItem(evento) {
	return (dispatch, getState) => {
		axios.get(`${consts.API_URL}/contratoItem/listarGeral`).then(resp => {
			dispatch({
				type: 'LAUDO_CONTRATO_ITEM_LISTADO',
				payload: resp
			});
			
			try {
				if (evento) {
					evento();
				}
			} catch(ex) {

			}
			
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function salvarImportacao(lista) {
	return (dispatch, getState) => {
		dispatch(setAguardando(true));
		axios.post(`${consts.API_URL}/laudoImportacao`, {
			lista: lista.map(item => ({
				...item,
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			})),
		}).then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getListaResumido());
			dispatch(setModoTela('lista'));
			dispatch(setAguardando(false));
		}).catch(e => {
			setErroAPI(e);
			dispatch(setAguardando(false));
		});
	};
}

export function salvar(registro) {
	return (dispatch, getState) => {
		axios.put(`${consts.API_URL}/laudoImportacao`, {
			...registro,
			quantidade: FormatUtils.formatarValorBanco(registro.quantidade, 0),
			valor: FormatUtils.formatarValorBanco(registro.valor, 2),
			percentual_imposto: FormatUtils.formatarValorBanco(registro.percentual_imposto, 2),
			id_usuario_alteracao: getState().auth.usuario.id
		}).then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getListaResumido());
			dispatch(setModoTela('listaImportada', {
				...registro
			}));
			dispatch(initForm({
				...registro
			}));
		}).catch(e => {
			setErroAPI(e);
		});
	};
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/laudoImportacao?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function excluirGeral(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/laudoImportacao/excluirGeral?competencia=${registro.competencia}&id_hospital=${registro.id_hospital}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getListaResumido());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function adicionarExameIgorado(registro, evento) {
	return (dispatch, getState) => {
		axios.put(`${consts.API_URL}/contrato/examesIgnorar`, {
			...registro,
			id_usuario_alteracao: getState().auth.usuario.id
		}).then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getListaContratoItem(evento));
		}).catch(e => {
			setErroAPI(e);
			if (evento) {
				evento();
			}
		});
	};
} 